<template>
  <LayoutAccordionItemComponent
    :class="$style.root"
    :active="active"
  >
    <template #heading>
      <h2 :class="$style.title">
        {{ title }}
      </h2>
      <h3
        v-if="subtitle"
        :class="$style.subtitle"
      >
        {{ subtitle }}
      </h3>
      <CoreDateTimeRangeComponent
        :dateStart="localizedData?.date_start"
        :dateEnd="localizedData?.date_end"
        :class="$style.dates"
      />
    </template>

    <template #content>
      <CoreImageSliderComponent
        v-if="entry?.images?.data"
        :images="entry?.images?.data"
      />

      <CoreTextComponent
        v-if="desciption"
        :string="desciption"
        :class="$style.text"
      />
    </template>
  </LayoutAccordionItemComponent>
</template>

<script setup>
const props = defineProps({
  entry: Object,
  active: {
    type: Boolean,
    default: false
  }
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(props?.entry)
})

const title = computed(() => i18nGetLocalizedTitle(localizedData.value))
const subtitle = computed(() => i18nGetLocalizedString(localizedData.value?.subtitles))
const desciption = computed(() => i18nGetLocalizedString(localizedData.value?.descriptions))
</script>

<style module>
.root {
  position: relative;
}

.title,
.subtitle {
  composes: reset-heading  from global;
}

.dates {
  composes: font-size-small from global;
}

.text {
  composes: font-size-small from global;
  margin: var(--unit--vertical) 0;
}
</style>
